import { countries } from './countries';
import { languages } from './languages';

function get(mapping: Record<string, string>, code: string): string {
  const lowerCaseCode = code.toLowerCase();

  return mapping[lowerCaseCode] || lowerCaseCode;
}

export function getCountryName(code: string): string {
  return get(countries, code);
}

export function getFullLangName(code: string): string {
  return get(languages, code);
}

function find(mapping: Record<string, string>, search: string): string[] {
  const searchLowerCase = search.toLowerCase();

  return Object.keys(mapping).filter((code) => (
    searchLowerCase === code || mapping[code].toLowerCase().includes(searchLowerCase)
  ));
}

export function findCountryCodes(search: string): string[] {
  return find(countries, search);
}

export function findLangCodes(search: string): string[] {
  return find(languages, search);
}
